import type { DataItem as TotalPackageStepNewAirRoadCustomTableDataItem } from '@/components/customTables/TotalPackageStepNewAirRoadCustomTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  productsPackages: openapi.AirroadSingleCreateBodyOpenapi['items'],
): TotalPackageStepNewAirRoadCustomTableDataItem {
  const volume =
    Math.ceil(
      productsPackages.reduce(function (accumulator, productsPackage) {
        return accumulator + Math.ceil((productsPackage.volume || 0) * 1000);
      }, 0),
    ) / 1000;

  const weight =
    Math.ceil(
      productsPackages.reduce(function (accumulator, productsPackage) {
        return accumulator + Math.ceil((productsPackage.weight || 0) * 1000);
      }, 0),
    ) / 1000;

  const cubicWeight = volume * 250;

  return {
    quantity: getStrCell(productsPackages.length),
    volume: getStrCell(volume),
    weight: getStrCell(weight),
    cubicWeight: getStrCell(cubicWeight),
    isCubicWeightError: cubicWeight > weight,
  };
}
